module.exports = [
	{
		"id": "3",
		"type": "content",
		"dir": "an-article-3",
		"title": "An article 3",
		"abstract": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
		"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.<br/><br/>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.<br/><br/>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
		"thumb": "test",
		"poster": "header",
		"sharetitle": "",
		"sharedescription": "",
		"sharemessage": "",
		"shareurl": "",
		"shareimg": "",
		"hashtags": "",
		"bgcolor": "#8493ca",
		"color": "#333333",
		"date": "June 11, 2017"
	},
	{
		"id": "2",
		"type": "link",
		"dir": "an-article-2",
		"title": "This is another article",
		"abstract": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
		"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
		"thumb": "test",
		"poster": "header",
		"image": [],
		"sharetitle": "",
		"sharedescription": "",
		"sharemessage": "",
		"shareurl": "",
		"shareimg": "",
		"hashtags": "",
		"bgcolor": "#8493ca",
		"color": "#333333",
		"date": "June 09, 2017",
		"source": "Lorem ipsum [source]",
		"url": "http://www.google.co.uk/"
	},
	{
		"id": "1",
		"type": "content",
		"dir": "an-article-1",
		"title": "An article 1",
		"abstract": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
		"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
		"thumb": "test",
		"poster": "header",
		"sharetitle": "",
		"sharedescription": "",
		"sharemessage": "",
		"shareurl": "",
		"shareimg": "",
		"hashtags": "",
		"bgcolor": "#8493ca",
		"color": "#333333",
		"date": "June 04, 2017"
	},
	{
		"id": "0",
		"type": "content",
		"dir": "an-article-0",
		"title": "An article 0",
		"abstract": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
		"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
		"thumb": "test",
		"poster": "header",
		"sharetitle": "",
		"sharedescription": "",
		"sharemessage": "",
		"shareurl": "",
		"shareimg": "",
		"hashtags": "",
		"bgcolor": "#8493ca",
		"color": "#333333",
		"date": "June 01, 2017"
	}
];


//////////////////
// WEBPACK FOOTER
// ./content.json
// module id = 3
// module chunks = 1